import { createAction } from 'redux-actions'
import get from 'lodash.get'

import history from '../../history'
import { IS_APPLICATION_LOADING, SHOW_USER_FEEDBACK } from '../../actions/types'
import { FETCH_DATA_TABLE_WITH_PARAMS } from '../LoadTable/types'
import {
  centrifugeStatus,
  getChannels,
  startCentrifuge,
  subscribeChannels,
} from '../../actions/centrifuge'
import LoadDetailsService from '../LoadsDetails/service'
import { LOAD_ACCEPT } from '../LoadsDetails/actionTypes'
import { resetUpdates } from '../Loads2/actions'
import LoadsService from '../Loads2/service'
import { handleGetFiltersFromUrl } from '../../utils/filterUtils'

import loadsApi from './service'
import { cachedLoadsPaginationSize, cachedLoadStateSchema, COLUMNS_NAME, formatPayloadBySearchAdvanced } from './utils'
import { formatHashChannel } from './websocketUtils'


export const FETCH_CACHED_LOADS_BY_STATUS = 'FETCH_CACHED_LOADS_BY_STATUS'
export const FETCH_CACHED_LOADS = 'FETCH_CACHED_LOADS'
export const FETCH_CACHED_COUNT = 'FETCH_CACHED_COUNT'
export const SET_NEW_LOADS_FILTERS = 'SET_NEW_LOADS_FILTERS'

const STATUS_LIST = ['NEGOTIATION', 'HIRED', 'IN_TRANSIT', 'IN_PROGRESS', 'DELIVERED']

export const fetchCachedLoads =
  ({
    columnStatus,
    sortDirection = cachedLoadStateSchema.sortDirection,
    page = 1,
    size = cachedLoadsPaginationSize,
    filters,
  }) =>
    async (dispatch) => {
      dispatch(createAction(IS_APPLICATION_LOADING)(true))
      try {
        const response = await loadsApi.fetchLoads({
          ...filters,
          status: columnStatus,
          size,
          page,
          sortDirection,
        })

        dispatch(
          createAction(FETCH_CACHED_LOADS_BY_STATUS)({
            key: COLUMNS_NAME[columnStatus],
            data: response.data,
            lastUpdate: new Date().getTime(),
            page,
            sortDirection,
            renderException: false,
          }),
        )
        if (columnStatus === 'NEGOTIATION') {
          centrifugeStatus().then(async (response) => {
            if (response === 'connected') {
              dispatch(getChannels(true))
            } else {
              await dispatch(startCentrifuge(() => dispatch(getChannels(true)), true))
            }
          })
        }
      } catch (err) {
        dispatch(
          createAction(FETCH_CACHED_LOADS_BY_STATUS)({
            key: COLUMNS_NAME[columnStatus],
            data: [],
            lastUpdate: new Date().getTime(),
            page: 1,
            sortDirection,
            renderException: true,
          }),
        )
      } finally {
        dispatch(createAction(IS_APPLICATION_LOADING)(false))
      }
    }

export const fetchAllCachedLoads =
  ({ page = 1, sortDirection = cachedLoadStateSchema.sortDirection, ...rest }) =>
    async (dispatch) => {
      dispatch(resetUpdates())
      dispatch(createAction(IS_APPLICATION_LOADING)(true))
      const promises = STATUS_LIST.map((columnStatus) =>
        loadsApi.fetchLoads({
          status: columnStatus,
          ...rest,
          sortDirection,
          page,
          size: cachedLoadsPaginationSize,
        }),
      )
      try {
        const loadsAuctionIds = []
        const state = {}
        const res = await Promise.allSettled(promises)

        res.forEach((result) => {
          if (result.value) {
            const { data, config } = result.value
            if (data.length > 0) {
              data.forEach((load) => {
                if (config.params.status === 'NEGOTIATION' && load.shippingType === 'AUCTION') {
                  loadsAuctionIds.push(load.hashId)
                }
              })
            }
            state[COLUMNS_NAME[config.params.status]] = {
              list: data,
              page: 1,
              hasMore: data.length >= cachedLoadsPaginationSize,
              lastUpdate: new Date().getTime(),
              sortDirection,
              renderException: false,
            }
            return
          }

          const { data = [], config } = result.reason

          state[COLUMNS_NAME[config.params.status]] = {
            list: data,
            page: 1,
            hasMore: data.length >= cachedLoadsPaginationSize,
            lastUpdate: new Date().getTime(),
            sortDirection,
            renderException: true,
          }
        })

        const auctionChannels = loadsAuctionIds.map((id) => formatHashChannel(id))
        const subscribeAuctionChannels = () => {
          if (auctionChannels.length) {
            dispatch(subscribeChannels(auctionChannels, true))
          }
        }

        centrifugeStatus().then(async (response) => {
          if (response === 'connected') {
            dispatch(getChannels(true))
            subscribeAuctionChannels()
          } else {
            await dispatch(startCentrifuge(() => {
              dispatch(getChannels(true))
              subscribeAuctionChannels()
            }, true))
          }
        })

        dispatch(createAction(FETCH_CACHED_LOADS)(state))
      } finally {
        dispatch(createAction(IS_APPLICATION_LOADING)(false))
      }
    }

export const fetchAllCachedLoadsWithSortDirection =
  ({ page = 1, ...rest }) =>
    async (dispatch, getState) => {
      dispatch(resetUpdates())
      dispatch(createAction(IS_APPLICATION_LOADING)(true))
      const loads = get(getState(), 'newLoads', {})

      const promises = STATUS_LIST.map((columnStatus) =>
        loadsApi.fetchLoads({
          status: columnStatus,
          ...rest,
          sortDirection: loads[COLUMNS_NAME[columnStatus]].sortDirection,
          page,
          size: cachedLoadsPaginationSize,
        }),
      )
      try {
        const loadsAuctionIds = []
        const res = await Promise.allSettled(promises)
        const state = {}

        res.forEach((result) => {
          if (result.value) {
            const { data, config } = result.value
            if (data.length > 0) {
              data.forEach((load) => {
                if (config.params.status === 'NEGOTIATION' && load.shippingType === 'AUCTION') {
                  loadsAuctionIds.push(load.hashId)
                }
              })
            }
            const key = COLUMNS_NAME[config.params.status]

            state[key] = {
              list: data,
              page: 1,
              hasMore: data.length >= cachedLoadsPaginationSize,
              lastUpdate: new Date().getTime(),
              sortDirection: loads[key].sortDirection,
              renderException: false,
            }
            return
          }
          const { data = [], config } = result.reason
          const key = COLUMNS_NAME[config.params.status]

          state[COLUMNS_NAME[config.params.status]] = {
            list: data,
            page: 1,
            hasMore: data.length >= cachedLoadsPaginationSize,
            lastUpdate: new Date().getTime(),
            sortDirection: loads[key].sortDirection,
            renderException: true,
          }
        })

        const auctionChannels = loadsAuctionIds.map((id) => formatHashChannel(id))
        const subscribeAuctionChannels = () => {
          if (auctionChannels.length) {
            dispatch(subscribeChannels(auctionChannels, true))
          }
        }

        centrifugeStatus().then(async (response) => {
          if (response === 'connected') {
            dispatch(getChannels(true))
            subscribeAuctionChannels()
          } else {
            await dispatch(startCentrifuge(() => {
              dispatch(getChannels(true))
              subscribeAuctionChannels()
            }, true))
          }
        })

        dispatch(createAction(FETCH_CACHED_LOADS)(state))
      } finally {
        dispatch(createAction(IS_APPLICATION_LOADING)(false))
      }
    }

export const fetchAllCount = (payload) => async (dispatch) => {
  dispatch(createAction(IS_APPLICATION_LOADING)(true))
  const promises = STATUS_LIST.map((columnStatus) =>
    loadsApi.fetchCount({
      ...payload,
      status: columnStatus,
    }),
  )
  try {
    const res = await Promise.allSettled(promises)
    res.forEach((result) => {
      if (result.value) {
        const { data, config } = result.value
        dispatch(
          createAction(FETCH_CACHED_COUNT)({ key: COLUMNS_NAME[config.params.status], count: data }),
        )
        return
      }
      const { data = 0, config } = result.reason
      dispatch(
        createAction(FETCH_CACHED_COUNT)({ key: COLUMNS_NAME[config.params.status], count: data }),
      )
    })
  } finally {
    dispatch(createAction(IS_APPLICATION_LOADING)(false))
  }
}

export const fetchDataTable =
  ({ tableTab, operationGroups, searchStatus = [], trackingStatus, ...rest }) =>
    (dispatch, state) => {
      const { status } = state().loadTable

      const orderBy = state().loadTable.status[tableTab].orderBy
      dispatch(createAction(IS_APPLICATION_LOADING)(true))
      const data = {}
      let fields
      if (tableTab === 'negotiation' && searchStatus.length > 0) {
        fields = [...searchStatus]
      }
      if (tableTab !== 'negotiation' && searchStatus.length > 0) {
        fields = [...searchStatus, status[tableTab].searchStatus]
      }
      if (tableTab !== 'negotiation' && !searchStatus.length) {
        fields = [...status[tableTab].searchStatus]
      }
      const page = 1
      loadsApi
        .fetchLadsForTable({
          status: tableTab.toUpperCase(),
          operationGroups,
          searchStatus: fields,
          launchType: tableTab === 'negotiation' ? status.negotiation.launchType : [],
          trackingStatus: tableTab === 'in_progress' ? trackingStatus : undefined,
          orderBy,
          ...rest,
        })
        .then((result) => {
          if (result.status === 200) {
            data[tableTab] = result.data
            data.status = tableTab
            data.page = page
            dispatch(createAction(FETCH_DATA_TABLE_WITH_PARAMS)(data))
            return
          }
          data[tableTab] = []
          data.status = tableTab
          data.page = page
          dispatch(createAction(FETCH_DATA_TABLE_WITH_PARAMS)(data))
        })
        .finally(() => dispatch(createAction(IS_APPLICATION_LOADING)(false)))
    }

export const acceptLoad =
  ({ hashId, possibleFreightPriceId }) =>
    (dispatch, getState) => {
      dispatch(createAction(IS_APPLICATION_LOADING)(true))
      LoadDetailsService.acceptLoad(hashId, possibleFreightPriceId)
        .then((result) => {
          if (!result.ok) {
            return dispatch(
              createAction(SHOW_USER_FEEDBACK)({
                feedbackMessage: 'Não foi possível realizar o aceite da carga!',
                feedbackType: 'MESSAGE',
                styleFeedbackType: 'error',
                messageTimestamp: new Date().getTime(),
              }),
            )
          }
          dispatch(createAction(LOAD_ACCEPT)(result))
          dispatch(
            createAction(SHOW_USER_FEEDBACK)({
              feedbackMessage: 'Aceite de frete enviado.',
              feedbackTitle: null,
              feedbackType: 'MESSAGE',
              styleFeedbackType: 'success',
              messageTimestamp: new Date().getTime(),
            }),
          )
          const operationIds = get(getState(), 'settings.operationGroups', []).map((item) => item.id)

          const search = history.location.search
          const payload = handleGetFiltersFromUrl(search, {
            defaultValues: { operationGroups: operationIds },
            defaultReturnTypes: {
              operationGroups: [],
              searchStatus: [],
              waitingAtLogisticOperator: 'boolean',
              flProposalSended: 'boolean',
              flShippingNotViewed: 'boolean',
              flLotAvailable: 'boolean',
            },
          })

          dispatch(fetchAllCachedLoadsWithSortDirection(formatPayloadBySearchAdvanced(payload)))
          dispatch(fetchAllCount(formatPayloadBySearchAdvanced(payload)))
        })
        .finally(() => dispatch(createAction(IS_APPLICATION_LOADING)(false)))
    }


export const groupLoads = (selectedShippings) => async (dispatch, getState) => {
  dispatch(createAction(IS_APPLICATION_LOADING)(true))
  LoadsService.groupShippings(selectedShippings)
    .then((res) => {
      dispatch(createAction(IS_APPLICATION_LOADING)(false))
      if (!res.ok) {
        return dispatch(
          createAction(SHOW_USER_FEEDBACK)({
            feedbackMessage: 'Não foi possível realizar o agrupamento das cargas!',
            feedbackType: 'MESSAGE',
            styleFeedbackType: 'error',
            messageTimestamp: new Date().getTime(),
          }),
        )
      }

      const operationIds = get(getState(), 'settings.operationGroups', []).map((item) => item.id)

      const search = history.location.search
      const payload = handleGetFiltersFromUrl(search, {
        defaultValues: { operationGroups: operationIds },
        defaultReturnTypes: {
          operationGroups: [],
          searchStatus: [],
          waitingAtLogisticOperator: 'boolean',
          flProposalSended: 'boolean',
          flShippingNotViewed: 'boolean',
          flLotAvailable: 'boolean',
        },
      })

      dispatch(fetchAllCachedLoadsWithSortDirection(formatPayloadBySearchAdvanced(payload)))
      dispatch(fetchAllCount(formatPayloadBySearchAdvanced(payload)))
    })
    .finally(() => dispatch(createAction(IS_APPLICATION_LOADING)(false)))
}

export const setNewLoadsFilters = (payload) => (dispatch) => {
  dispatch(createAction(SET_NEW_LOADS_FILTERS)(payload))
}
